import { Fragment } from 'react';
import logo from '../assets/logo/logo-min.png'
import mainTemplate from '../assets/code-snippets/main-template.js';
import Footer from '../components/Footer/Footer'
import downloadFile from '../assets/poke-css.rar'
import packageInfo from '../assets/poke-css/package.json'

import Snippet from '../components/Snippet/Snippet'

const Home = () => {

    return <Fragment>
        <div className="container fluid pt-3">
            <span style={{ position: 'absolute', top: '2px', right: '5px', fontSize: '0.8rem', zIndex: '-1px', }}>Updated: 04/05/2022</span>
            <div className="container xl">
                <div className="row align-items-center">

                    <div className="col md-III">
                        <p className="text xxl">A fast way to build Web Apps UI.</p>
                        <p className="text md">
                            Design mobile responsive websites or web applications by using POKE-CSS,
                            front-end open source CSS library designed to enhance performance and lowering disk memory
                            usage.</p>
                        <div className="container fluid py-2">
                            <a href={downloadFile} className="btn lg outline">Download</a>
                            <p className="text sm">Curently <span className="bold">v{packageInfo.version}</span></p>
                            <p className="text md">NPM package: <a href="https://www.npmjs.com/package/poke-css" target="_blank" rel="noreferrer">https://www.npmjs.com/package/poke-css</a></p>
                            <p className="text md">GitHub repository: <a href="https://github.com/cosminneaga/poke-css" target="_blank" rel="noreferrer">https://github.com/cosminneaga/poke-css</a></p>
                        </div>
                    </div>

                    <div className="col md-III order-md-first">
                        <div className="container fluid p-5">
                            <img className="responsive-image shadow-sm rounded-lg-lb" src={logo} alt="cosmin's CSS main logo" title="POKE-CSS" />
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div className="spacer md"></div>


        <div className="container md py-3 text-center rounded-lg primary shadow-rt">
            <p className="text xl bold">Minimal setup</p>
            <p className="text md">POKE-CSS provides a minimal setup of styles for a fast and clean starting point.
                Specially designed for better performance and simplistic starting setup.<br /><br /> <span className="bounce">I hope you'll enjoy working with POKE-CSS!</span></p>
        </div>

        <div className="spacer md"></div>

        <div className="container md">
            <p className="text xl primary underline">'Starting point</p>

            <p className="text md"> POKE-CSS is a personal project started in Octomber 2020 as a single man project, most of the
                inspiration has been taken by the author after the popular CSS libraries out there. This
                project is intended to save developers time, when building a new website or an UI for web
                applications. </p>
        </div>

        <div className="spacer lg"></div>

        <div className="container primary py-1">
            <div className="container xl my-5">

                <div className="row align-items-center">

                    <div className="col md-III p-3">

                        <p className="text xxl warning bold">Installation</p>
                        <p className="text md"> Install source SCSS files using npm. </p>
                        <p className="text sm"> Package installs will not include any documentation. You can use the npm install
                            command to install the package into your project, the
                            entire documentation lies onto this presentation website. For more details about how to install
                            this package please use the button below to be redirected to installation page. </p>
                        <a href="/install" target="_blank" rel="noreferrer" className="btn sm wide outline light">Open installation page</a>
                    </div>

                    <div className="col md-III">
                        <p className="text md">NPM install command</p>
                        <Snippet code='npm install poke-css' language="cmd" />
                    </div>

                </div>

            </div>
        </div>

        <div className="spacer md"></div>

        <div className="container md">
            <p className="text xxl info bold">Starter Template</p>
            <p className="text md"> In order to have POKE-CSS setup correctly, you need to make sure that your web pages have included
                latest
                HTML5 standards. Your starting template should look like this. </p>

            <Snippet code={mainTemplate} language="html" />
        </div>

        <div className="spacer md"></div>

        <div className="container fluid py-5 dark">
            <div className="container xl">
                <div className="row">
                    <div className="col md-III py-3">
                        <p className="text xl info bold">Open source</p>
                        <p className="text lg">
                            POKE-CSS is open-sourced project and feedbacks are welcome
                        </p>
                        <a href="https://www.facebook.com/pokecss" className="btn xl outline light" target="_blank" rel="noreferrer">Visit us
                            on
                            facebook</a>
                    </div>

                    <div className="col md-III py-3">
                        <p className="text xl bold info">Keep in touch</p>
                        <ul style={{ listStyle: 'none' }}>
                            <li>Share feedback on GitHub</li>
                            <li>Chat with us</li>
                            <li>Follow us on Facebook</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="spacer md"></div>
        </div>

        <Footer />
    </Fragment>
}

export default Home